import { render, staticRenderFns } from "./DialogoLancamento.vue?vue&type=template&id=5f6b95ee&scoped=true&"
import script from "./DialogoLancamento.vue?vue&type=script&setup=true&lang=js&"
export * from "./DialogoLancamento.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6b95ee",
  null
  
)

export default component.exports